import React, { useState } from 'react';
import { Bell } from 'lucide-react';

const Notifications = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [notifications] = useState([
    {
      id: 1,
      title: "Migration Completed",
      message: "Vector Embedding from ChromaDB to Qdrant",
      time: "2 minutes ago",
      type: "success"
    },
    {
      id: 2,
      title: "Migration Failed",
      message: "Vector Embedding from Qdrant to Weaviate",
      time: "15 minutes ago",
      type: "error"
    },
    {
      id: 3,
      title: "New Migration Started",
      message: "Vector Index from Pinecone to Weaviate",
      time: "1 hour ago",
      type: "info"
    }
  ]);

  return (
    <div className="relative">
      <button
        onClick={() => setShowDropdown(!showDropdown)}
        className="relative w-10 h-10 bg-[#141414] border border-gray-800 rounded-lg flex items-center justify-center hover:bg-gray-800 transition-colors"
      >
        <Bell className="w-5 h-5 text-gray-400" />
        {notifications.length > 0 && (
          <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 rounded-full text-white text-xs flex items-center justify-center">
            {notifications.length}
          </span>
        )}
      </button>

      {/* Dropdown */}
      {showDropdown && (
        <>
          {/* Backdrop */}
          <div
            className="fixed inset-0 z-10"
            onClick={() => setShowDropdown(false)}
          />
          
          {/* Dropdown Content */}
          <div className="absolute right-0 mt-2 w-80 bg-[#141414] border border-gray-800 rounded-lg shadow-xl z-20">
            <div className="p-4 border-b border-gray-800">
              <h3 className="text-sm font-semibold text-white">Notifications</h3>
            </div>
            <div className="max-h-96 overflow-y-auto">
              {notifications.map((notification) => (
                <div
                  key={notification.id}
                  className="p-4 border-b border-gray-800 hover:bg-gray-800/30 transition-colors cursor-pointer"
                >
                  <div className="flex items-start gap-3">
                    <div
                      className={`w-2 h-2 mt-2 rounded-full flex-shrink-0 ${
                        notification.type === 'success'
                          ? 'bg-emerald-500'
                          : notification.type === 'error'
                          ? 'bg-red-500'
                          : 'bg-blue-500'
                      }`}
                    />
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium text-white">
                        {notification.title}
                      </p>
                      <p className="text-xs text-gray-400 mt-1">
                        {notification.message}
                      </p>
                      <p className="text-xs text-gray-500 mt-1">
                        {notification.time}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="p-3 border-t border-gray-800">
              <button className="w-full text-center text-sm text-blue-400 hover:text-blue-300 transition-colors">
                View all notifications
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Notifications;